import React from 'react';

interface SummaryRow {
  label: string;
  value: React.ReactNode;
  bold?: boolean;
}

interface BillingSummaryCardProps {
  rows: SummaryRow[];
  style?: React.CSSProperties;
}

/**
 * A styled billing summary card (blue border, rows of label : value).
 * Used in StripeBilling and potentially CardDetails.
 */
const BillingSummaryCard: React.FC<BillingSummaryCardProps> = ({ rows, style }) => (
  <div style={{
    background: 'linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%)',
    border: '2px solid #0f3a7d',
    borderRadius: 12,
    padding: 20,
    marginBottom: 24,
    ...style,
  }}>
    {rows.map((row, i) => (
      <div key={row.label} style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: i < rows.length - 1 ? 12 : 0,
        paddingTop: i === rows.length - 1 && rows.length > 1 ? 12 : 0,
        borderTop: i === rows.length - 1 && rows.length > 1 ? '1px solid #dee2e6' : 'none',
        fontSize: row.bold ? 14 : 13,
        fontWeight: row.bold ? 600 : undefined,
        color: row.bold ? '#0f3a7d' : undefined,
      }}>
        <span style={{ color: row.bold ? '#0f3a7d' : '#666' }}>{row.label}</span>
        <span style={{ fontWeight: 600, color: row.bold ? '#0f3a7d' : '#333' }}>{row.value}</span>
      </div>
    ))}
  </div>
);

export default BillingSummaryCard;
